// extracted by mini-css-extract-plugin
module.exports = {"logo":"Sider_logo__vqT4g","sider":"Sider_sider__2qRPY","menu":"Sider_menu__2TjMb","active":"Sider_active__38wsi"};